// Reduce y comprime una foto en el navegador antes de enviarla (las fotos del
// celular pesan varios MB). Devuelve un data URL JPEG.
// ladoMaximo alto porque el E-14 es largo y los números deben leerse.
export const comprimirImagen = (archivo, { ladoMaximo = 2400, calidad = 0.75 } = {}) =>
  new Promise((resolve, reject) => {
    if (!archivo?.type?.startsWith("image/")) {
      reject(new Error("El archivo seleccionado no es una imagen"));
      return;
    }

    const url = URL.createObjectURL(archivo);
    const imagen = new Image();

    imagen.onload = () => {
      const escala = Math.min(1, ladoMaximo / Math.max(imagen.width, imagen.height));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(imagen.width * escala);
      canvas.height = Math.round(imagen.height * escala);
      canvas.getContext("2d").drawImage(imagen, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);
      resolve(canvas.toDataURL("image/jpeg", calidad));
    };

    imagen.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("No se pudo leer la imagen"));
    };

    imagen.src = url;
  });
